import mixpanel from 'mixpanel-browser';

const source = 'dashboard:sentiment_graph';
const sentiments = ['Positive', 'Negative', 'Neutral'];

export default {
    trackSentimentSelection(value) {
        const selectedSentiments = sentiments.filter(sentiment => !value.includes(sentiment));

        mixpanel.track(`${source}:sentiment_selected`, {
            'Sentiment Enabled': selectedSentiments
        });
    }
};
